var Featuredcontent;

Featuredcontent = function(self, options) {
  Selectable(self);
  Observable(self, 'section');
  Observable(self, 'title');
  Observable(self, 'sub_title');
  Editable(self, 'type', (function(_this) {
    return function(new_type) {
      return self.api().update(self.gallery_id, self.id, {
        type: new_type
      });
    };
  })(this));
  Editable(self, 'external_id', (function(_this) {
    return function(new_external_id) {
      return self.api().update(self.gallery_id, self.id, {
        external_id: new_external_id
      });
    };
  })(this));
  Editable(self, 'boxtitle', (function(_this) {
    return function(new_boxtitle) {
      return self.api().update(self.gallery_id, self.id, {
        boxtitle: new_boxtitle
      });
    };
  })(this));
  Editable(self, 'content', (function(_this) {
    return function(new_content) {
      return self.api().update(self.gallery_id, self.id, {
        content: new_content
      });
    };
  })(this));
  self.api = function() {
    return api.featuredcontent;
  };
  self.update = (function(_this) {
    return function(data, callback) {
      return self.api().update(self.id, data).done(callback);
    };
  })(this);
  self.move = (function(_this) {
    return function(to, callback) {
      return self.api().update(self.id, {
        sort: to
      }).done(callback);
    };
  })(this);
  self["delete"] = (function(_this) {
    return function(callback) {
      return self.api().destroy(self.id).done(callback);
    };
  })(this);
  return self;
};

api.add('featuredcontent');

Featuredcontent.find = function(section, options, callback) {
  return api.featuredcontent.read(section).done(callback);
};

Featuredcontent.create = function(data, callback) {
  return api.featuredcontent.create(data).done(callback);
};

//# sourceMappingURL=featuredcontent.js.map
